var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-list-item",
    {
      class: _vm.cssClasses,
      on: {
        click: function ($event) {
          $event.stopPropagation()
          return _vm.clicked.apply(null, arguments)
        },
      },
    },
    [
      _c(
        "v-list-item-content",
        [_c("v-list-item-title", [_vm._v(_vm._s(_vm.navigationText))])],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }